import React from "react";

const Footer = () => {
    return (
        <footer className="fixed bottom-0 left-0 w-full bg-gray-50 text-black py-4 z-50">
            <div className="container mx-auto text-center">
                <p className="text-sm">
                    &copy; {new Date().getFullYear()} The Grad Story. All rights reserved.
                </p>
            </div>
        </footer>

    );
};

export default Footer;
